import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { highFive } from '@/assets';

export const FeedbackSuccess = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}>
      <Typography variant="h2" mb={1}>
        Feedback Received!
      </Typography>
      <Typography variant="body2">
        Thanks for sharing your thoughts. Every response helps us make LumiQ
        episodes even more relevant and engaging for you.
      </Typography>
      <Box
        component="img"
        src={highFive}
        sx={[
          { mx: 'auto' },
          isMobile
            ? { width: 160, height: 160, my: 2 }
            : { width: 240, height: 240, my: 6 },
        ]}
      />
    </Box>
  );
};
